import { makeStyles, Theme } from '@material-ui/core/styles'

interface StyleProps {
  colors: {
    accentColor: string
    colorBackgroundSecundary: string
    cardAccentColor: string
    accentColorBackground: string
    textAccentColor: string
    textBody: string
  }
}

const stylesServiceProfile = makeStyles<Theme, StyleProps>((theme) => ({
  main: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    height: 'auto',
    backgroundColor: '#fff',
    padding: `0rem .5rem 2.5rem .5rem`,
  },
  title: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 500,
    color: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(20),
    },
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: 700,
  },
  textTitle: (props) => ({
    color: props.colors.accentColor,
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(30),
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(24),
    },
  }),
  card: {
    maxWidth: 360,
    width: '100%',
    height: 218,
    background: '#E7EDED',
    color: theme.palette.primary.main,
    display: 'flex',
    cursor: 'pointer',
  },
  contentBody: {
    margin: '20px 20px 0px 20px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
  },
  icons: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 18,
  },
  itemIcon: {
    margin: '0px 3px',
  },
  contentTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    margin: '40px 0px',
  },
  contentCards: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.typography.pxToRem(16),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
    },
    [theme.breakpoints.down('sm')]: {
      margin: '0 1rem',
      gridTemplateColumns: '1fr',
    },
  },
  contentInfo: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%',
    maxWidth: 360,
    marginBottom: 20,
  },
  contentActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    margin: '40px 0px 20px 0px',
  },
  button: {
    width: '100%',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    maxWidth: 200,
    height: 46,
    transition: 'opacity 0.3s ease',
    borderRadius: 0,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      opacity: '0.8',
    },
    [theme.breakpoints.down('sm')]: {
      maxWidth: 257,
      height: 53,
    },
  },
  textButton: {
    fontWeight: 700,
    fontSize: theme.typography.pxToRem(14),
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(18),
    },
  },
}))

export default stylesServiceProfile
